import List from './List';
import EditServer from './Edit'
import CreateServer from './CreateServer'
const resource = {
    list: List,
    edit: EditServer,
    create: CreateServer
};

export default resource;